export const initialDeliveryCoordinates = { lat: "", lng: "" };
export const initialDeliveryAddressParts = { address: "", reference: "", commune: "" };

export const normalizeCoordinateValue = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue.toFixed(6) : "";
};

export const normalizeAddressPart = (value) => String(value || "").trim();

export const normalizeCommuneName = (value) => String(value || "").trim().toUpperCase();

export const buildDeliveryAddressString = (parts = {}) =>
  [parts.address, parts.commune]
    .map((v) => normalizeAddressPart(v))
    .filter(Boolean)
    .join(", ");

export const extractDeliveryAddressParts = (address = {}) => ({
  address: [
    address.road || address.pedestrian || address.footway || address.path || "",
    address.house_number || "",
  ]
    .map((v) => String(v || "").trim())
    .filter(Boolean)
    .join(" "),
  reference: "",
  commune: String(
    address.city || address.town || address.village || address.municipality
    || address.suburb || address.city_district || address.county || ""
  ).trim(),
});